import { Delete, Upload } from "@mui/icons-material";
import { Avatar, Button, Stack, Typography } from "@mui/material";
import * as React from "react";

const UploadPhoto = ({
  onChange,
  value,
}: {
  onChange: (file: File | null) => void;
  value?: string;
}) => {
  const [image, _setImage] = React.useState<string | null>(null);
  const inputFileRef = React.createRef<HTMLInputElement>();

  const cleanup = () => {
    if (!!image) URL.revokeObjectURL(image!);

    inputFileRef!.current!.value = "";
  };

  const setImage = (newImage: string | null) => {
    if (image) cleanup();

    _setImage(newImage);
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newImage = event.target?.files?.[0];
    if (newImage) {
      const objectUrl = URL.createObjectURL(newImage);
      setImage(objectUrl);

      onChange(newImage);
    }
  };

  const handleClick = (event: any) => {
    if (image) {
      event.preventDefault();
      setImage(null);
    }
  };

  return (
    <Stack direction="row" alignItems="center">
      <Avatar
        variant="square"
        sx={{ bgColor: "primary.main", width: 100, height: 100, mr: 2 }}
        src={image || value || "./broken-image.jpg"}
      />
      <input
        ref={inputFileRef}
        accept="image/*"
        hidden
        id="avatar-image-upload"
        type="file"
        onChange={handleOnChange}
      />
      <label htmlFor="avatar-image-upload">
        <Button
          variant="outlined"
          component="span"
          onClick={handleClick}
          sx={{
            borderColor: "#F4A259",
            color: "#F4A259",
            "&:hover": {
              backgroundColor: "rgba(244, 162, 89, 0.08)",
              borderColor: "#F4A259",
            },
          }}
        >
          <>
            {image ? <Delete /> : <Upload />}
            {image ? "Reset" : "Select Photo"}
          </>
        </Button>
      </label>
      {/* <Typography variant="caption" display="block" gutterBottom>
      </Typography> */}
    </Stack>
  );
};
export default UploadPhoto;
